import { defineComponent as _defineComponent } from 'vue'
import { ITask } from "@/api/types/tasks";
import TaskStatus from "@/components_v3/tasks/TaskStatus.vue";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgEye from "@/assets/icons/eye.svg";
import SvgLink from "@/assets/icons/link.svg";
import { getFormatDate } from "@/utils/formatDates";
import { useRouter } from "vue-router/composables";
import TaskDeleteTooltip from "@/components_v3/tasks/TaskDeleteTooltip.vue";
import { useCopyText } from "@/utils/copyText";

interface Props {
    task: ITask;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TaskMobileCard',
  props: {
    task: null
  },
  emits: ['update-list'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    task: ITask;
}



const router = useRouter();

const info = [
    { text: 'Дата задачи', value: getFormatDate(props.task.date, 'dd.MM.yyyy'), isDate: true },
    { text: 'Автор', value: props.task.created_by?.name! },
    { text: 'Исполнитель', value: props.task.assignee?.name! },
];

const getText = () => {
    return props.task.text.replace(/<figure[^>]*>/g,"").replace(/<img[^>]*>/g,"").replaceAll('&nbsp;', '');
};

const getWeekday = () => {
    return `${getFormatDate(props.task.date, 'EEEEEE')}.`;
};

const redirectToTask = () => {
    router.push({ name: 'task', params: { id: props.task.id } });
};

const copyLinkToTask = () => {
    const path = router.resolve({ name: 'task', params: { id: props.task.id } }).href;
    const domain = window.location.origin;
    const link = `${domain}${path}`;
    useCopyText(link, 'Ссылка на задачу скопирована');
};


return { __sfc: true,props, emits, router, info, getText, getWeekday, redirectToTask, copyLinkToTask, TaskStatus, BaseButtonV2, SvgEye, SvgLink, TaskDeleteTooltip }
}

})